/**
 * Canonical display order for FIELD_OPTIONS groups, shared by every field-group
 * picker in the import feature (the legacy MappingPhase field select and the
 * transform-aware TargetFieldSelect).
 */
import type { FieldOptionItem } from '@ooh/contracts';

export type FieldGroupKey = FieldOptionItem['group'];

export const GROUP_ORDER: FieldGroupKey[] = [
  'general',
  'physical',
  'mural_flags',
  'digital',
  'internal_cost',
  'client_price',
];
